import { Button, Card, Form, Input, InputNumber, Select, Space, Table, Tag, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import PageTitle from "../page-header/PageHeader";
import { loadAllAdvances, createAdvance, deleteAdvance } from "../../redux/actions/hr/advanceActions";
import { loadAllWorkers } from "../../redux/actions/hr/workerActions";

const AdvancePage = () => {
  const dispatch = useDispatch();
  const { list, total, loading } = useSelector((s) => s.advances);
  const { list: workers } = useSelector((s) => s.workers);
  const [page, setPage] = useState(1);
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    dispatch(loadAllAdvances({ page, count: 20 }));
    dispatch(loadAllWorkers({ query: "all", status: "true" }));
  }, [dispatch, page]);

  const handleAdd = async () => {
    setSaving(true);
    try {
      const values = await form.validateFields();
      const payload = {
        worker_id: values.worker_id,
        amount: values.amount,
        date: values.date ? values.date.toISOString() : new Date().toISOString(),
        note: values.note || null,
      };
      const resp = await dispatch(createAdvance(payload));
      if (resp.message === "success") {
        form.resetFields();
        dispatch(loadAllAdvances({ page, count: 20 }));
      }
    } catch (e) { /* validation */ }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    await dispatch(deleteAdvance(id));
    dispatch(loadAllAdvances({ page, count: 20 }));
  };

  const columns = [
    { title: "Worker", key: "worker", render: (_, r) => r.worker?.name || r.worker_id },
    { title: "Dept", key: "dept", render: (_, r) => r.worker?.department || "-" },
    { title: "Amount", dataIndex: "amount", key: "amount", render: (v) => `₹${v.toLocaleString()}` },
    { title: "Date", dataIndex: "date", key: "date", render: (v) => dayjs(v).format("DD-MMM-YYYY") },
    { title: "Status", dataIndex: "status", key: "status", render: (v) => <Tag color={v === "pending" ? "orange" : v === "deducted" ? "green" : "red"}>{v}</Tag> },
    { title: "Note", dataIndex: "note", key: "note" },
    {
      title: "", key: "actions", width: 80,
      render: (_, r) => <Button size="small" danger onClick={() => handleDelete(r.id)}>Del</Button>,
    },
  ];

  return (
    <>
      <PageTitle title="Back" />
      <Card title="Quick Advance Entry" style={{ marginBottom: 16 }}>
        <Form form={form} layout="inline">
          <Form.Item name="worker_id" rules={[{ required: true, message: "Select worker" }]}>
            <Select showSearch optionFilterProp="children" placeholder="Worker" style={{ width: 200 }}>
              {(workers || []).map((w) => (
                <Select.Option key={w.id} value={w.id}>{w.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="amount" rules={[{ required: true, message: "Enter amount" }]}>
            <InputNumber placeholder="Amount ₹" style={{ width: 130 }} />
          </Form.Item>
          <Form.Item name="date">
            <DatePicker placeholder="Date" />
          </Form.Item>
          <Form.Item name="note">
            <Input placeholder="Note (optional)" style={{ width: 180 }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={handleAdd} loading={saving}>Record Advance</Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="All Advances">
        <Table
          dataSource={list}
          columns={columns}
          rowKey="id"
          loading={loading}
          size="small"
          pagination={{ current: page, total, pageSize: 20, onChange: setPage }}
        />
      </Card>
    </>
  );
};

export default AdvancePage;
